

function NavbarPart() {
    return (
        <>
            <nav className="navbar-part">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="navbar-content">

                                {/* NAV LINKS */}
                                <ul className="navbar-list">

                                    <li className="navbar-item ">
                                       <a class="navbar-link" href="#">home</a>
                                    </li>

                                    <li className="navbar-item ">
                                        <a  class="navbar-link" href="#">
                                            Women
                                        </a>
                                    </li>

                                    <li className="navbar-item">
                                        <a  class="navbar-link" href="#">Man</a>
                                    </li>

                                    <li className="navbar-item">
                                        <a  class="navbar-link" href="#">Kids</a>
                                    </li>
                                    <li className="navbar-item">
                                        <a  class="navbar-link" href="About">About</a>
                                    </li>

                                    <li className="navbar-item">
                                        <a  class="navbar-link" href="Faq">Faq</a>
                                    </li>

                                    <li className="">
                                        <a  class="navbar-link" className="" href="TermCondition">
                                            Term & condition
                                        </a>
                                        {/* <ul className="dropdown-position-list">
                                            <li><a href='blog-grid.html'>blog grid</a></li>
                                            <li><a href='blog-standard.html'>blog standard</a></li>
                                            <li><a href='blog-details.html'>blog details</a></li>
                                            <li><a href='blog-author.html'>blog author</a></li>
                                        </ul> */}
                                    </li>

                                </ul>

                                {/* RIGHT SIDE INFO */}
                                <div className="navbar-info-group">
                                    <div className="navbar-info">
                                        <i className="icofont-ui-touch-phone"></i>
                                        <p>
                                            <small>call us</small>
                                            <span>(+91) 929645475</span>
                                        </p>
                                    </div>

                                    <div className="navbar-info">
                                        <i className="icofont-ui-email"></i>
                                        <p>
                                            <small>email us</small>
                                            <span>support@paraksh.com</span>
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </nav>
        </>
    );
}

export default NavbarPart;
